import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import {
  ALL_SURVEYS,
  ALL_SURVEYS_CHANGE_STATUS,
  ALL_SURVEYS_DELETE,
} from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AllListSurveyDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadListSurvey =
  (): ThunkAction<Promise<void>, State, null, AllListSurveyDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: ALL_SURVEYS + REQUEST });
    try {
      const payload = await api.loadAllSurvey();
      dispatch({ type: ALL_SURVEYS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ALL_SURVEYS + FAILURE, error });
    }
  };

export const allListSurveyIdle = () => ({ type: ALL_SURVEYS + IDLE });

export const allListSurveyDelete = (deleteSurveyId: number) => ({
  type: ALL_SURVEYS_DELETE,
  payload: deleteSurveyId,
});

export const allListSurveyPublish = (
  publishSurveyId: number,
  newStatus: number,
) => ({
  type: ALL_SURVEYS_CHANGE_STATUS,
  payload: { id: publishSurveyId, status: newStatus },
});
